import PersistentDrawerLeft from "../../components/NewDrawer";
import CustomControlledEditor from "../../components/formValidation/CustomControlledEditor";
import {useEffect, useState} from "react";
import {Box, Button, Stack, Typography} from "@mui/material";
import useCallDataApi from "../../hooks/data";
import Loading from "../../components/Loading";
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import {useSnackbar} from "notistack";
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';

const EmailTemplates = () => {
    const {getData: fetchEmailTemplates, postData: postEmailTemplates} = useCallDataApi('email-templates')
    const [variables, setVariables] = useState([])
    const [loading, setLoading] = useState(true)
    const [emailTexts, setEmailTexts] = useState({
        order_confirmation_email: '',
        order_cancellation_email: '',
        new_order_email: ''
    })
    const [errors, setErrors] = useState({})
    const {enqueueSnackbar} = useSnackbar();

    useEffect(() => {
        fetchEmailTemplates('get_variables').then(r => setVariables(r))
        fetchEmailTemplates('get_templates')
            .then(r => setEmailTexts({
                order_confirmation_email: r?.order_confirmation_email || '',
                order_cancellation_email: r?.order_cancellation_email || '',
                new_order_email: r?.new_order_email || ''
            }))
            .finally(() => setLoading(false))
    }, [])

    const editEmailTemplates = () => {
        setLoading(true)
        postEmailTemplates('edit_templates', emailTexts)
            .then(r => {
                setEmailTexts({
                    order_confirmation_email: r?.order_confirmation_email || '',
                    order_cancellation_email: r?.order_cancellation_email || '',
                    new_order_email: r?.new_order_email || ''
                })
                enqueueSnackbar('Sablonok elmentve!', {variant: 'success'})
            })
            .finally(() => setLoading(false))
    }

    const validators = {
        order_confirmation_email: [(value) => ({ valid: true })],
        order_cancellation_email: [(value) => ({ valid: true })],
        new_order_email: [(value) => ({ valid: true })]
    }

    return <PersistentDrawerLeft title='Email sablonok'>
        <Typography variant='h4' gutterBottom>E-mail változók:</Typography>
        <Stack spacing={2} direction='row' marginBottom={3} sx={{ flexWrap: 'wrap' }}>
            {variables.map(v => <Button variant='outlined' endIcon={<ContentCopyRoundedIcon/>} key={v.id} onClick={() => navigator.clipboard.writeText(v.value).then(() => enqueueSnackbar('Másolva!', {variant: 'success'}))}>{v.name}</Button>)}
        </Stack>
        <CustomControlledEditor 
            title='Rendelés megerősítése email' 
            name="order_confirmation_email"
            data={emailTexts}
            setData={setEmailTexts}
            errors={errors}
            setErrors={setErrors}
            validators={validators}
        />
        <CustomControlledEditor 
            title='Rendelés törlése email' 
            name="order_cancellation_email"
            data={emailTexts}
            setData={setEmailTexts}
            errors={errors}
            setErrors={setErrors}
            validators={validators}
        />
        <CustomControlledEditor 
            title='Új rendelés email' 
            name="new_order_email"
            data={emailTexts}
            setData={setEmailTexts}
            errors={errors}
            setErrors={setErrors}
            validators={validators}
        />
        <Box sx={{width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: 2}}>
            <Button onClick={() => editEmailTemplates()} variant='contained' color='success' endIcon={<SaveRoundedIcon/>}>Mentés</Button>
        </Box>
        <Loading isLoading={loading}/>
    </PersistentDrawerLeft>
}

export default EmailTemplates